import React from "react";
import { Link } from "react-router-dom";

const Columns = ({ getActions }) => [
  {
    id: "program_name",
    header: "Program Name",
    accessor: "program_name",
    sortable: true,
    searchable: true,
  },
  {
    id: "manager",
    header: "Manager",
    accessor: (row) => row.manager ? `${row.manager.name}` : '',
    sortable: true,
    searchable: true,
  },
  {
    id: "actions",
    header: "Actions",
    accessor: (row) => getActions(row),
    sortable: false,
    searchable: false,
  }
];

export default Columns;